import { useGaiaWebsocket } from "@expert/gaia";
import { useEffect } from "react";

import { useActiveTask, useLogger, usePartner, useSessionId, type VoiceTask } from "@/sdk";

/**
 * Sends the current smart offer checklist session context keys to Gaia via update-session-context.
 * Gaia uses these keys (from product checklist items) to know which checklist items are available
 * for the current session (e.g. for gaia-sales-checklist-mentions).
 */
export function useSetGaiaSmartOfferChecklistContext(sessionContextKeys: string[]) {
    const gaiaWS = useGaiaWebsocket();
    const partner = usePartner();
    const sessionId = useSessionId();
    const task = useActiveTask();
    const callSid = (task as VoiceTask)?.agentCallId;
    const logger = useLogger();

    useEffect(() => {
        if (!sessionContextKeys.length || !gaiaWS || gaiaWS.loading) return;
        logger.info({ sessionContextKeys }, "Setting Gaia Smart Offer Checklist Context");

        void gaiaWS.sendJsonMessage({
            action: "update-session-context",
            correlationId: sessionId,
            sessionId: callSid ?? sessionId,
            sessionGroupId: sessionId,
            partner,
            context: {
                properties: [
                    {
                        field: "realtime_tools",
                        value: sessionContextKeys.join(","),
                        action: "add",
                    },
                ],
            },
        });
    }, [callSid, gaiaWS, partner, sessionContextKeys, sessionId, logger]);
}
